export default __webpack_public_path__ + "static/media/Custom EE GLI-Brookshire Bros (3-pln+NIS) 11-22.8c063d16.pdf";